import { DispositionReasonType, DispositionSpecificationType } from '@/api/apis/case';
import { dispositionReasonsNames, dispositionSpecificationNames } from '@/constants/case/case.constants';

export const mapDropdownValues = <T extends Record<string, string>>(values: (keyof T)[], names: T) =>
  values.map((r) => ({
    value: r,
    name: names[r],
  }));

// DeclineType.Aborted
const cancelReasonsAbortedValues = [
  DispositionReasonType.CancelledByTransMedics,
  DispositionReasonType.ByTxCenter,
  DispositionReasonType.WithdrawnByOPO,
  DispositionReasonType.ErroneousCase,
];
export const cancelReasonsAborted = mapDropdownValues(cancelReasonsAbortedValues, dispositionReasonsNames);

// DeclineType.DryRun
export const cancelReasonsDryRunValues = [
  DispositionReasonType.DCDDonorDidNotExpire,
  DispositionReasonType.TurndownByTxCenter,
  DispositionReasonType.OCSContraindication,
  DispositionReasonType.DeviceMalfunction,
  DispositionReasonType.DonationWithdrawnByOPO,
  DispositionReasonType.SurgicalError,
  DispositionReasonType.Other,
];
export const cancelReasonsDryRun = mapDropdownValues(cancelReasonsDryRunValues, dispositionReasonsNames);

// DeclineType.Turndown
const cancelReasonsTurndownValues = [
  DispositionReasonType.TurndownByTxCenter,
  DispositionReasonType.DeviceMalfunction,
  DispositionReasonType.DonationWithdrawnByOPO,
  DispositionReasonType.SurgicalError,
  DispositionReasonType.Other,
];
export const cancelReasonsTurndown = mapDropdownValues(cancelReasonsTurndownValues, dispositionReasonsNames);

// DispositionReasonType.CancelledByTransMedics
const specificationsCancelledByTmdxValues = [
  DispositionSpecificationType.OCSContraindicationOrNotSuitable,
  DispositionSpecificationType.NoClinicalSpecialists,
  DispositionSpecificationType.NoSurgeon,
  DispositionSpecificationType.NoDevice,
  DispositionSpecificationType.TooShortNotice,
  DispositionSpecificationType.NoGroundTransport,
  DispositionSpecificationType.NoPlanes,
  DispositionSpecificationType.Other,
];
export const specificationsCancelledByTmdx = mapDropdownValues(
  specificationsCancelledByTmdxValues,
  dispositionSpecificationNames,
);

// DispositionReasonType.ByTxCenter
const specificationsCancelledByTxValues = [
  DispositionSpecificationType.DonorReasons,
  DispositionSpecificationType.RecipientReasons,
  DispositionSpecificationType.LogisticalIssues,
  DispositionSpecificationType.AcceptedAlternateDonor,
  DispositionSpecificationType.AlternatePreservationMethod,
  DispositionSpecificationType.Other,
];
export const specificationsCancelledByTx = mapDropdownValues(
  specificationsCancelledByTxValues,
  dispositionSpecificationNames,
);

// DispositionReasonType.TurndownByTxCenter
const specificationsTurndownByTxValues = [
  DispositionSpecificationType.DonorQuality,
  DispositionSpecificationType.OrganNotViable,
  DispositionSpecificationType.RecipientReasons,
  DispositionSpecificationType.LogisticalIssues,
  DispositionSpecificationType.TXCenterAcceptanceCriteria,
  DispositionSpecificationType.AlternatePreservationMethod,
  DispositionSpecificationType.Other,
];
export const specificationsTurndownByTx = mapDropdownValues(
  specificationsTurndownByTxValues,
  dispositionSpecificationNames,
);

// Specification is not required
export const specificationNone = [
  { value: DispositionSpecificationType.None, name: dispositionSpecificationNames[DispositionSpecificationType.None] },
];
